import { useDataSource } from '@/features/data/DataSourceContext';
import { useAppSelector } from '@/store/hooks';
import { useGetSettingsQuery } from './api/settings.api';

/**
 * The signed-in person's photo, as the shell shows it: the one saved on
 * Settings → Account this session, else the mock's settings. Live leaves it to
 * the bootstrap's photo — its settings are a dozen calls, not loaded per page.
 */
export function useProfilePhotoUrl(): string | undefined {
  const { source } = useDataSource();
  const saved = useAppSelector((state) => state.ui.profilePhoto);
  const settings = useGetSettingsQuery({ source, params: undefined }, { skip: source === 'live' });
  return saved ?? settings.data?.account.photoUrl;
}
